import apiClient from './client';

export interface CpuMetrics {
  load_average: { '1min': number; '5min': number; '15min': number };
  cores: { logical: number; physical: number };
  usage_percent: number;
  times_percent: { user: number; system: number; idle: number; iowait: number };
}

export interface RamMetrics {
  total_bytes: number;
  used_bytes: number;
  available_bytes: number;
  percent: number;
  buffers_bytes: number;
  cached_bytes: number;
}

export interface SwapMetrics {
  total_bytes: number;
  used_bytes: number;
  percent: number;
}

export interface DiskUsage {
  total_bytes: number;
  used_bytes: number;
  free_bytes: number;
  percent: number;
}

export interface DiskIoCounters {
  read_bytes: number;
  write_bytes: number;
  read_count: number;
  write_count: number;
  busy_time_ms: number;
}

export interface VolumeInfo {
  name: string;
  service: string;
  size_bytes: number;
}

export interface NetworkMetrics {
  bytes_sent: number;
  bytes_recv: number;
  packets_sent: number;
  packets_recv: number;
  errin: number;
  errout: number;
  dropin: number;
  dropout: number;
}

export interface SystemMetrics {
  cpu: CpuMetrics;
  memory: { ram: RamMetrics; swap: SwapMetrics };
  disk: { usage: DiskUsage; io_counters?: DiskIoCounters; volumes: VolumeInfo[] };
  network: NetworkMetrics;
  uptime_seconds: number;
  hostname: string;
  timestamp: string;
}

export const systemMetricsApi = {
  async getMetrics(): Promise<SystemMetrics> {
    const response = await apiClient.get<SystemMetrics>('/system-metrics');
    return response.data;
  },
};
